import { Field, FormTheme, Label } from '@kanda-libs/ks-component-ts';
import useMonthlyPayment from './useMonthlyPayment';

const MonthlyPayment: React.FunctionComponent = function ({}) {
  const { validation, isLoading } = useMonthlyPayment();
  return (
    <div className="flex flex-col">
      <Label label="Amount you can repay each month" />
      <FormTheme variant="emphasized">
        <Field.Validator validation={validation}>
          <Field.NumberInput
            name="amountToPayMonthly"
            label=""
            type="price"
            isLoading={isLoading}
          />
        </Field.Validator>
      </FormTheme>
    </div>
  );
};

export default MonthlyPayment;
